import { ErrorMessage } from '@hookform/error-message';
import { type FC, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

import { useForm } from 'react-hook-form';
import type { PackagesResponse } from '../../../modules/interfaces';

interface PropertyConfigModalProps {
  show: boolean;
  packagesData: PackagesResponse;
  handleClose: () => void;
  onSave: (data: PriorityValue) => void;
  maxPriority: number;
}

export const paymentStatusColorMapper: Record<string, string> = {
  CONFIRMED: 'primary',
  STARTED: 'warning',
};

export interface PriorityValue {
  priority?: number;
  name?: string;
  uuid?: string;
}

export const EditPackagePriorityModal: FC<PropertyConfigModalProps> = ({
  show,
  packagesData,
  handleClose,
  onSave,
  maxPriority,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      priority: 0,
      name: '',
      uuid: '',
    },
  });

  const onClose = () => {
    handleClose();
  };

  const onSubmit = async (data: PriorityValue) => {
    const validated = await trigger(['priority']);
    if (validated) {
      onSave(data);
      handleClose();
    }
  };

  useEffect(() => {
    if (packagesData && show) {
      reset({
        priority: packagesData.priority,
        name: packagesData.name,
        uuid: packagesData.uuid,
      });
    }
  }, [packagesData, show]);

  return (
    <Modal
      show={show}
      onHide={() => {
        handleClose();
      }}
      size="lg"
      backdrop="static"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Header>
          <Modal.Title className="h5">Add-ons Priorities</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mt-16px">
            <Row>
              <Col xs={2}>
                <Form.Label className="editor-title-label">Priority</Form.Label>
                <Form.Control
                  className="editor-control"
                  placeholder="Enter priority"
                  {...register('priority', {
                    required: 'This is required',
                    min: { value: 1, message: 'Priority must be at least 1' },
                    max: {
                      value: maxPriority,
                      message: `Priority cannot be greater than ${maxPriority}`,
                    },
                  })}
                />
                <ErrorMessage
                  errors={errors}
                  name="priority"
                  render={({ message }) => <span className="error-text">{message}</span>}
                />
              </Col>
              <Col>
                <Form.Label className="editor-title-label">Add-ons name</Form.Label>
                <Form.Control
                  className="editor-control"
                  placeholder="Enter add-on name"
                  readOnly
                  {...register('name', { required: 'This is required' })}
                />
              </Col>
            </Row>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <div>
            <Button
              className="cancel-button"
              style={{ marginRight: '10px' }}
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button className="save-button" type="submit">
              Confirm
            </Button>
          </div>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
